/**
 * Copyright (C) Schweizerische Bundesbahnen SBB, 2016.
 *
 * Routendefinition
 *
 * @author u220374 (Reto Lehmann)
 * @version: 2.0.0
 * @since 14.07.2016, 2016.
 */
import {ModuleWithProviders} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {environment} from '../environments/environment';
import {routes as authRoutes} from './auth/auth-routing.module';
import {AuthGuard} from './auth/auth.guard';
import {zkkSelectedGuard} from './auth/zkk-selected.guard';

const tippsTitle = $localize`:@@TIPPS_NAV_TITLE:Einführung neuer Buchungsprozess`;

export const appRoutes: Routes = [
  {path: '', pathMatch: 'full', loadComponent: () => import('./view/landing-page/landing-page.component').then(m => m.LandingPageComponent)},
  {path: 'about', redirectTo: ''},
  {path: 'snake', loadComponent: () => import('./view/snake/snake.component').then(m => m.SnakeComponent)},
  {path: 'settings', loadChildren: () => import('./settings/settings.module').then(m => m.SettingsModule), canActivate: [AuthGuard]},
  {path: 'push', loadChildren: () => import('./push/push.module').then(m => m.PushModule)},
  {path: 'auth', children: authRoutes}, // no lazy loading as auth module is eagerly loaded!
  {path: 'direct', loadChildren: () => import('./secure-link/secure-link.module').then(m => m.SecureLinkModule)},
  {path: 'ebooking', loadChildren: () => import('./ebooking/ebooking.module').then(m => m.EbookingModule)},
  {path: 'schedule', loadChildren: () => import('./fahrplan/fahrplan.routes').then(m => m.fahrplanRoutes), canActivate: [AuthGuard, zkkSelectedGuard]},
  {path: 'user-cockpit', loadChildren: () => import('./user-cockpit/user-cockpit.routes').then(m => m.userCockpitRoutes), canActivate: [AuthGuard, zkkSelectedGuard]},
  {path: 'internal-user-cockpit', loadChildren: () => import('./user-cockpit/internal-user-cockpit.routes').then(m => m.userCockpitRoutes), canActivate: [AuthGuard]},
  {path: 'storage-cockpit', loadChildren: () => import('./storage/storage-cockpit/storage-cockpit.module').then(m => m.StorageCockpitModule)},
  {path: 'release-notes/:id', loadComponent: () => import('./release-notes/release-notes-view/release-notes-view.component').then(m => m.ReleaseNotesViewComponent)},
  {path: 'release-notes', loadComponent: () => import('./release-notes/release-notes-view/release-notes-view.component').then(m => m.ReleaseNotesViewComponent)},
  {path: 'disruption-alerts/:id', loadComponent: () => import('./stoerungsmeldungen/stoerungsmeldungen-view/stoerungsmeldungen-view.component').then(m => m.StoerungsmeldungenViewComponent)},
  {path: 'disruption-alerts', loadComponent: () => import('./stoerungsmeldungen/stoerungsmeldungen-view/stoerungsmeldungen-view.component').then(m => m.StoerungsmeldungenViewComponent)},
  {
    path: 'tips/:id',
    loadComponent: () => import('./tipps/tipps-view/tipps-view.component').then(m => m.TippsViewComponent),
    title: tippsTitle
  },
  {
    path: 'tips',
    loadComponent: () => import('./tipps/tipps-view/tipps-view.component').then(m => m.TippsViewComponent),
    title: tippsTitle
  },
  ...(environment.production ? [] : [{path: 'demo', loadChildren: () => import('./demo/demo.module').then(m => m.DemoModule)}]),
  {path: 'billing-download/:token', loadComponent: () => import('./billing/view/billing-download-view.component').then(m => m.BillingDownloadViewComponent)},
  {
    path: 'storage',
    redirectTo: 'costs-overview'
  },
  {path: 'costs-overview', loadChildren: () => import('./costs-overview/costs-overview.routes').then(m => m.costsOverviewRoutes)},
  {path: '**', redirectTo: ''}
];

export const routing: ModuleWithProviders<RouterModule> = RouterModule.forRoot(appRoutes, {
  useHash: false,
  initialNavigation: 'disabled' // initial navigation is triggered in AuthEffects.onInitCheckLogin$
});
